module.exports = __webpack_public_path__ + "img/0Q3A4053_L_WoodMatted_MockedUp.6b95832e.jpg";